import type { SVGProps } from 'react';

export const ShiningStarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 48 48"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="currentColor"
      d="m41.992 37.2-4.78-4.8 1.58-1.58 4.8 4.78-1.6 1.6Zm-6.796-23.635-1.58-1.58 4.78-4.781 1.6 1.58-4.8 4.781Zm-22.8.02-4.78-4.8 1.58-1.581 4.8 4.78-1.6 1.6ZM5.58 37.2 4 35.6l4.78-4.78 1.6 1.58-4.8 4.8Zm9.904.05 8.312-4.989 8.331 5.058-2.197-9.438 7.304-6.327-9.638-.858-3.8-8.88-3.781 8.83-9.639.838 7.304 6.366-2.195 9.4ZM12.063 42l3.096-13.3-10.362-8.969 13.67-1.174L23.795 6l5.35 12.558 13.669 1.173L32.454 28.7 35.55 42l-11.754-7.066L12.062 42Z"
    />
  </svg>
);
